class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.isHovering = false;
    this.isDesktop = window.innerWidth >= 990;

    this.setupHover();
  }

  setupHover() {
    const details = this.mainDetailsToggle;

    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 990;
    });

    details.addEventListener('mouseenter', () => {
      if (!this.isDesktop) return;
      this.isHovering = true;
      clearTimeout(this.hoverTimeout);
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', true);
      this.onToggle();
    });

    details.addEventListener('mouseleave', () => {
      if (!this.isDesktop) return;
      this.isHovering = false;
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        if (!this.isHovering) {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', false);
          this.onToggle();
        }
      }, 200);
    });

    details.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        if (!this.isDesktop) return;
        if (e.target.closest('a.header__menu-item-link')) return;
        e.preventDefault();
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', false);
          this.onToggle();
        } else {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', true);
          this.onToggle();
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
